// Mapování well-known sémantických klíčů akcí (z hlavičky legacy okna) na Phoenix ikony.
// Známý klíč → samostatné tlačítko s ikonou; neznámý → kebab s textovým labelem.

import type { WellKnownActionKey } from '@/shared/legacyMagicBridge';
import type { PhxIconName } from '@/shared/ui/icon';

const ICON_BY_KEY: Record<WellKnownActionKey, PhxIconName> = {
  reload: 'refresh',
  lock: 'lock',
  unlock: 'unlock',
  help: 'help',
  copy: 'copy',
  edit: 'edit',
  delete: 'trash',
  add: 'plus',
  languages: 'globe',
  detail: 'search',
};

/** Vrátí Phoenix ikonu pro well-known klíč, nebo undefined (→ kebab). */
export function wellKnownIcon(key: string | undefined): PhxIconName | undefined {
  if (!key) return undefined;
  return ICON_BY_KEY[key as WellKnownActionKey];
}
